import React, { useMemo, useState } from 'react'
import { useGlobalFilter, usePagination, HeaderGroup, Accessor, useSortBy, useTable } from 'react-table'
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';
import ButtonDownloadReportTable from "components/Varios/Tabla/ComponentButtonExcel"
import { Container, Row, Col, Button } from 'react-bootstrap';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { Table } from 'reactstrap'
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import config from "config.json";
import { CustomStyleColumn } from '../../../Types/GeneralTypes';

import pdfSVG from '../../../../assets/icons/Permisos/PDF(azul).svg'


export default function TableHistorialPermisos({ dataFilas, onClickVerDocumento, anioSeleccionado, onChangeAnio }) {
    
  const [anioMostrado, setanioMostrado] = useState(anioSeleccionado);


  function GetComponenteVerDocumentoPDF(referencia) {
    var referenciaNoEsValidad = referencia === null || referencia === undefined || referencia === ""
    if (!referenciaNoEsValidad) {
      return (
        <i
                data-toggle="tooltip" data-placement="top" title="Vista Previa Documento"
                onClick={() => onClickVerDocumento(referencia)}
            >
                <img
                    src={pdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                    className="acciones"
                    alt="Vista Previa Documento"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Vista Previa Documento"
                    style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                />
            </i>
        /*<Button style={{ backgroundColor: "#FFC200", float: "none", height: "27px", width: "27px" }} className="m-0 p-1 btn-icono" onClick={() => onClickVerDocumento(referencia)}>
          <i className="fas fa-eye" aria-hidden="true" ></i>
        </Button>*/
      )
    }
    else {
      return (<div></div>)
    }


  }

  const filas = useMemo(
    () => [...dataFilas], [dataFilas]
  )

  const columnas: any = React.useMemo(
    () => [
      {
        Header: 'Tipo Solicitud',
        accessor: 'strTipoPermiso',
      },
      {
        Header: 'Fecha Solicitud',
        accessor: 'fechaSolicitud',
        Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined
      },
      
      {
        Header: 'Fecha',
        accessor: 'fechaDesde',
        Cell: ({ value }) => value !== undefined ? ObtenerFechaFromIsoFormat(value) : undefined

      },
      {
        Header: 'Hora Desde',
        accessor: 'horaDesde',
       

      },
      {
        Header: 'Hora Hasta',
        accessor: 'horaHasta',
        
      },

      {
        Header: 'Estado',
        accessor: 'strEstadoPermiso',
      },
      {
        Header: "Certificado Médico",
        accessor: 'refArchivoCertMedico',
        Cell: ({ value }) => GetComponenteVerDocumentoPDF(value)
      },
      {
        Header: "Solicitud",
        accessor: 'refArchivoPermiso',
        Cell: ({ value }) => GetComponenteVerDocumentoPDF(value)
      }

      ,
    ], [dataFilas]
  )

    const columnasStyles = (cell): Array<CustomStyleColumn> => [
    {
      HeaderName: "Certificado Médico",
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
        HeaderName: "Solicitud",
        StyleHeader: {
          textAlign: "center"
        }
      },
    {
      HeaderName: "Estado",
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Tipo Solicitud',
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: "Fecha Solicitud",
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
        HeaderName: "Fecha",
        StyleHeader: {
          textAlign: "center"
        }
      },
    {
      HeaderName: "Hora Desde",
      StyleHeader: {
        textAlign: "center"
      }
    },
    {
      HeaderName: 'Hora Hasta',
      StyleHeader: {
        textAlign: "center"
      }
    }
  ]

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    visibleColumns,
    prepareRow,
    state,
    setGlobalFilter
  } = useTable(
    {
      columns: columnas,
      data: filas
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { globalFilter, pageIndex, pageSize } = state;
  const sizerows = filas.length;


    function HandleChangeAnioOnTable(anioSeleccionado) {

    if (typeof (anioSeleccionado) === "number") {
      setanioMostrado(anioSeleccionado.toString())
    }
        onChangeAnio(anioSeleccionado)
    }

  const BotonDescargarReporte = useMemo(() => {

    const URLAnios = "SolicitudPermisos/HistorialPermisos/AniosDisponibles";

      const URLREPORTE = "SolicitudPermisos/HistorialPermisos/Reporte"



    if (anioSeleccionado !== undefined) {

      const anioForButton = +anioSeleccionado

      return (
        <ButtonDownloadReportTable
          api={URLREPORTE}
          nombreBoton='Reporte Historial Permisos'
          apiYears={URLAnios}
          onChangeYearNotAsync={HandleChangeAnioOnTable}
          yearElegido={anioForButton}
        />
      )
    }

  }, [anioSeleccionado])


  return (
    <React.Fragment>
      <Row>
        <Col xl={12}>
          <div className="containerBtnAprobacionesVacLic">
              <GlobalFilterTable
                  filter={globalFilter}
                  setFilter={setGlobalFilter}
              />
              
          </div>
        </Col>
      </Row>
      <Row className="justify-content-end mb-1">
        <Col xl={3} lg={3} md={4} sm={12}>
          {BotonDescargarReporte}
        </Col>
      </Row>
      <Row>
        <Col xl={12}>
          <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
            <thead style={{}}>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                      className='clickable'
                    >
                      {column.render('Header')}
                      <span>
                        {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row, indirow) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()}>

                    {row.cells.map(cell => {
                      return getTdTableStyles(cell, { border: 'solid 1px black' }, indirow,columnasStyles(cell))

                    })}
                  </tr>
                )
              })}
            </tbody>
          </Table>
          <ComponentePaginacionTabla
            page={page}
            sizerows={sizerows}
            canNextPage={canNextPage}
            canPreviousPage={canPreviousPage}
            nextPage={nextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            previousPage={previousPage}
            setPageSize={setPageSize}

          />
        </Col>
      </Row>



    </React.Fragment>
  )
}